// removed by extract-text-webpack-plugin
module.exports = {"root":"EnterpriseError__root___2qXQK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseError/EnterpriseError.scss
// module id = 1009
// module chunks = 0